module.exports = __webpack_public_path__ + "img/fatherhood_13.7a995d18.jpg";